export const DEFAULT_QUERY = {
  keywords: [],
  near_keywords: [],
  not_near_keywords: [],
  near_distance: 10,
  not_near_distance: 10,
  exclude_channel_names: [],
  languages: [],
  sources: [],
  include_channel_names: [],
};

export const WORDS_APART_OPTIONS = [
  { value: 1, label: 1 },
  { value: 2, label: 2 },
  { value: 3, label: 3 },
  { value: 4, label: 4 },
  { value: 5, label: 5 },
  { value: 10, label: 10 },
  { value: 15, label: 15 },
  { value: 20, label: 20 },
  { value: 25, label: 25 },
  { value: 30, label: 30 },
  { value: 40, label: 40 },
  { value: 50, label: 50 },
];
